import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SearchModule} from '../../shared/components/search/search.module';
import {MappingsService} from '../../core/services/Mappings/mappings.service';
import {ClientsService} from '../../core/services/customer/clients.service';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PopulateModalModule} from '../../shared/components/modal/populate-modal.module';
import { CsvimportComponent } from './csvimport.component';
import { MatDividerModule } from '@angular/material/divider';
import { CsvImportService } from '../../core/services/csvImport/csv-import-service';

@NgModule({
  declarations: [
    CsvimportComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    PopulateModalModule,
    MatDividerModule,
    SearchModule
  ],
  providers: [
    MappingsService,
    ClientsService,
    CsvImportService
  ]
})
export class CSVImportModule { }
